<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	name: "perkawinanData",
	components: {},
	data() {
		return {
			info: {},
			currentPage: 1,
			totalPages: 0,
			loading: true,
			filters: {
				nama: { value: "", keys: ["nama"] },
				nama_pasangan: { value: "", keys: ["nama_pasangan"] },
				no_buku_lm: { value: "", keys: ["no_buku_lm"] },
				no_lm: { value: "", keys: ["no_lm"] },
			},
		};
	},
	created() {
		this.findAll();
	},
	mounted() {},
	computed: {
		...mapGetters({
			countAll: "umatPerkawinan/countAll",
		}),
		...mapState({
			myData: (state) => state.umatPerkawinan.data,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
		getJK() {
			return (jk) => (jk === "L" ? "Laki-laki" : "Perempuan");
		},
	},
	methods: {
		myFilter() {
			var d = new Date(this.filterDateValue);
			const filterDateValue = this.$moment(d).format("YYYY-MM-DD");

			switch (this.filterDate) {
				case "tanggal":
					this.filters.tanggal.value = filterDateValue;
					console.log("tanggal", filterDateValue);
					break;
				case "bulan":
					this.filters.tanggal.value = filterDateValue.slice(0, 7);
					console.log("bulan", filterDateValue.slice(0, 7));
					break;
				case "tahun":
					this.filters.tanggal.value = filterDateValue.slice(0, 4);
					console.log("tahun", filterDateValue.slice(0, 4));
					break;
				default:
					this.filters.tanggal.value = null;
					break;
			}
		},
		...mapActions({
			delete: "umatPerkawinan/delete",
		}),
		async findAll() {
			await this.$store.dispatch("umatPerkawinan/getAll");
		},
		refreshData() {
			this.findAll();
		},
		tambahData() {
			this.$router.push("/perkawinan/add");
		},
		getInfo(id) {
			this.info = this.$store.getters["umatPerkawinan/getById"](id);
		},
		setEdit(id) {
			this.$router.push("/perkawinan/edit/" + id);
		},
		swalConfirm(id) {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				customClass: {
					confirmButton: "btn btn-danger m-1",
					cancelButton: "btn btn-secondary m-1",
				},
				confirmButtonText: "Ya, Hapus!",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					return this.delete(id).then(
						(response) => {
							return Promise.resolve(response.data);
						},
						(error) => {
							this.$swal("Gagal!", JSON.stringify(error), "danger");
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== "undefined") {
					if (result.value) {
                  this.findAll()
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
		openModalFile(url) {
			this.$refs.modalfile.open();
			this.fileURL = url;
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Data perkawinan" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
									<b-button
										v-b-toggle.collapse-filter
										variant="primary"
										size="sm"
										v-b-tooltip.hover
										title="Filter"
										><i class="fa fa-filter"></i
									></b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="tambahData()"
										v-b-tooltip.hover
										title="Tambah"
										><i class="fa fa-plus"></i> Tambah</b-button
									>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>
				<!-- --------------------------- FILTER --------------------------- -->
				<b-collapse id="collapse-filter" class="mt-2">
					<div class="card-body pb-1 pt-1">
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Nama Umat</label>
									<input
										v-model="filters.nama.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Nama Pasangan</label>
									<input
										v-model="filters.nama_pasangan.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>No Buku LM</label>
									<input
										v-model="filters.no_buku_lm.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>No LM</label>
									<input
										v-model="filters.no_lm.value"
										class="form-control form-control-sm"
										type="text"
									/>
								</div>
							</div>
						</div>
						<hr />
					</div>
				</b-collapse>
				<!-- --------------------------- /FILTER --------------------------- -->

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<v-table
							class="
								table
								b-table
								table-vcenter table-striped table-bordered table-hover
							"
							:data="myData"
							:filters="filters"
							:currentPage.sync="currentPage"
							:pageSize="20"
							@totalPagesChanged="totalPages = $event"
						>
							<thead slot="head" class="thead-light">
								<v-th
									sortKey="id"
									defaultSort="desc"
									class="text-center"
									>ID</v-th
								>

								<th>Nama Umat</th>
								<th>Nama Pasangan</th>
								<th>No Buku LM</th>
								<th>No LM</th>
								<th>Tanggal Perkawinan</th>
								<th class="text-center">Action</th>
							</thead>
							<tbody slot="body" slot-scope="{ displayData }">
								<tr v-for="item in displayData" :key="item.id">
									<td class="text-center">{{ item.id }}</td>

									<td>{{ item.nama }}</td>
									<td>{{ item.nama_pasangan }}</td>
									<td>{{ item.no_buku_lm }}</td>
									<td>{{ item.no_lm }}</td>
									<td>{{ item.tgl_perkawinan_human }}</td>
									<td class="text-center">
										<b-btn-group>
											<b-button
												size="sm"
												variant="outline-dark"
												v-b-modal.modal-info
												@click="getInfo(item.id)"
												v-b-tooltip.hover
												title="Info"
											>
												<i class="fa fa-info"></i>
											</b-button>
											<b-button
												size="sm"
												variant="outline-dark"
												@click="setEdit(item.uid)"
												v-b-tooltip.hover
												title="Edit"
											>
												<i class="fa fa-edit"></i>
											</b-button>
											<b-button
												size="sm"
												variant="danger"
												@click="swalConfirm(item.uid)"
												v-b-tooltip.hover
												title="Delete"
											>
												<i class="fa fa-times"></i>
											</b-button>
										</b-btn-group>
									</td>
								</tr>

								<tr v-if="!displayData.length">
									<td colspan="100">
										<p class="text-center p-2">Tidak ada Data</p>
									</td>
								</tr>
							</tbody>
						</v-table>
						<smart-pagination
							:currentPage.sync="currentPage"
							:totalPages="totalPages"
							:maxPageLinks="3"
							:boundaryLinks="true"
						/>
					</template>
				</div>
			</div>
		</div>

		<b-modal
			id="modal-info"
			hide-footer
			size="lg"
			title="Informasi Data Perkawinan"
		>
			<div class="card shadow">
				<div class="card-body">
					<table class="table table-striped table-hover">
						<tbody>
							<tr>
								<td>Nama Umat</td>
								<td>:</td>
								<td>{{ this.info.nama }}</td>
							</tr>
							<tr>
								<td>Nama Pasangan</td>
								<td>:</td>
								<td>{{ this.info.nama_pasangan }}</td>
							</tr>
							<tr>
								<td>No. Buku LM</td>
								<td>:</td>
								<td>{{ this.info.no_buku_lm }}</td>
							</tr>
							<tr>
								<td>No. LM</td>
								<td>:</td>
								<td>{{ this.info.no_lm }}</td>
							</tr>
							<tr>
								<td>Tanggal Perkawinan</td>
								<td>:</td>
								<td>{{ this.info.tgl_perkawinan_human }}</td>
							</tr>
							<tr>
								<td>Imam Peneguh</td>
								<td>:</td>
								<td>{{ this.info.imam_peneguh }}</td>
							</tr>
							<tr>
								<td>Keuskupan LC</td>
								<td>:</td>
								<td>{{ this.info.keuskupan_lm }}</td>
							</tr>
							<tr>
								<td>Paroki LC</td>
								<td>:</td>
								<td>{{ this.info.paroki_lm }}</td>
							</tr>
							<tr>
								<td>Nama Wali 1</td>
								<td>:</td>
								<td>{{ this.info.wali }}</td>
							</tr>
							<tr>
								<td>Nama Wali 2</td>
								<td>:</td>
								<td>{{ this.info.wali2 }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<style scoped>
nav.smart-pagination {
	margin-top: 20px;
}
</style>